import _ from 'lodash'
import React, { useState } from 'react'
import useError from '@vero/ui-core-browser/hooks/error.js'
import useSubmit from '@vero/ui-core-browser/hooks/submit.js'
import Input from '@vero/ui-components/components/input.jsx'
import useClaims from '../hooks/claims.js'
import useEmail from '../hooks/email.js'
import useProviders from '../hooks/providers.js'
import EmailInput from '../components/email-input.jsx'
import PasswordInput from '../components/password-input.jsx'
import Providers from '../components/providers.jsx'
import SubmitButton from '../components/submit-button.jsx'

export default function ({ title, className }) {
  const [loading, setLoading] = useState(false)
  const { error, setError, handleError } = useError()
  const { email } = useEmail(false)
  const { providers, hasEmailProvider, isSsoUser } = useProviders(email, setLoading, setError, handleError)
  const [currentPassword, setCurrentPassword] = useState('')
  const [password, setPassword] = useState('')
  const { authClient } = useClaims()

  const onSubmit = useSubmit(setLoading, setError, handleError, async () => {
    if (email && !_.isEmpty(providers)) {
      if (currentPassword && password) {
        await authClient.changePassword(currentPassword, password)
      }
    }
  })

  return (
    <div className={className}>
      {error && <div className='alert alert-error'>{error}</div>}

      <div className='p-8'>
        <header className='flex justify-between items-baseline mb-6'>
          <h1 className='capitalize text-4xl font-light'>{title}</h1>
        </header>

        {!email && (
          <div className='flex flex-col'>
            <a href='/auth/login?r=/auth/change-password' className='btn btn-primary drop-shadow uppercase'>sign in</a>
          </div>
        )}

        {email && (
          <form onSubmit={onSubmit} className='mb-6'>
            <div className='flex flex-col gap-4'>
              <EmailInput
                className='grow'
                value={email}
                readOnly
              />

              {hasEmailProvider() && (
                <>
                  <Input
                    type='password'
                    name='current-password'
                    label='current password'
                    className='grow'
                    autoComplete='current-password'
                    value={currentPassword}
                    onChange={e => {
                      setError(null)
                      setCurrentPassword(e.target.value)
                    }}
                    required
                  />

                  {currentPassword && (
                    <>
                      <PasswordInput
                        label='new password'
                        className='grow'
                        value={password}
                        onChange={e => {
                          setError(null)
                          setPassword(e.target.value)
                        }}
                        required
                      />
                    </>
                  )}
                </>
              )}

              {isSsoUser() && (
                <p className='alert alert-info'>Your user is a single sign-on user and does not need a password. Please use one of your providers below to sign in.</p>
              )}

              <div className='flex flex-col gap-2'>
                {(_.isEmpty(providers) || hasEmailProvider()) && (
                  <div className='flex flex-col'>
                    <SubmitButton title={title} loading={loading} />
                  </div>
                )}

                <Providers providers={providers} />
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
